import { useState, useRef } from "react";
import { InputAdornment, TextField } from "@mui/material";
import { ClickAwayListener } from "@mui/base";
import { DefinedRange, DateRange } from "react-date-range";
import styles from "../../../dashboard/dashboard.module.scss";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { BOOKING_DATE_START_DATE } from "../../constants/date";
import { format } from "date-fns";

const formatDate = (date) => format(new Date(date), 'yyyy-MM-dd');

/**
 * Custom Date Range Picker Component
 * @param {Object} props - Props for the component
 * @param {Function} props.handleChange - Callback function triggered when the date range changes
 * @param {Array} props.ranges - Initial date range array with start and end dates
 * @param {String} props.label - Label for the TextField input
 * @param {String} props.adornment - Start adornment for the TextField input
 * @param {String} props.dateValue - Current value displayed in the input field
 * @param {String} props.cssClassName - Custom CSS class for the date range picker
 * @returns {JSX.Element} A Date Range Picker component
 */

const DateRangePicker = (props) => {
  const { handleChange, ranges, label, adornment, dateValue, cssClassName } = props;
  const [open, setOpen] = useState(false);
  //
  const refTarget = useRef(null);
  //
  let dateRange;
  if (ranges) {
    dateRange = [
      {
        startDate: formatDate(new Date(ranges[0].startDate)),
        endDate: formatDate(new Date(ranges[0].endDate)),
        key: "selection",
      },
    ];
  } else {
    dateRange = [
      {
        startDate: "",
        endDate: "",
        key: "selection",
      },
    ];
  }
  //
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div className="calendarWrap">
        <TextField
          id="booking date range picker"
          InputProps={{
            startAdornment: <InputAdornment position="start">{adornment}</InputAdornment>,
          }}
          label={label}
          value={dateValue}
          size="small"
          color="primary"
          onClick={() => setOpen(!open)}
          sx={{
            "& .MuiOutlinedInput-input": {
              fontSize: 12,
            },
            "& .MuiOutlinedInput-root": {
              height: "fit-content",
              padding: 0,
            },
          }}
          className="booking-font"
        />
        <div ref={refTarget}>
          {open && (
            <>
              <DefinedRange
                onChange={handleChange}
                ranges={dateRange}
                className={styles.bookingDefinedDateEement}
              />
              <DateRange
                onChange={handleChange}
                editableDateInputs
                moveRangeOnFirstSelection={false}
                ranges={dateRange}
                months={1}
                direction="horizontal"
                className={cssClassName}
                minDate={new Date(BOOKING_DATE_START_DATE)}
              />
            </>
          )}
        </div>
      </div>
    </ClickAwayListener>
  );
};
//
export default DateRangePicker;
